import { IUserInfo } from '~src/ts/models/IUserInfo';

import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { IShareAction } from './GetSharedWithMeRequest';

export interface ISharedVersion {
  id: string;
  contentType: string;
  name?: string; // this is required if content type is custom view
  isHidden?: boolean; // this is required if content type is custom view
  url?: string; // this is required if content type is custom view
}

export interface IGetShareActivityParams extends IGetItemsParams {
  viewId: string;
}

export interface IGetShareActivityResult extends IGetItemsResult {
  viewOrCustomizedViews: ISharedVersion[];
  deletedSharers: IUserInfo[];
  sharers: IUserInfo[];
  shareActions: IShareAction[];
}

export class GetShareActivityRequest extends Request<IGetShareActivityParams, IGetShareActivityResult> {
  constructor(params: IGetShareActivityParams) {
    super('getShareActivity', params);
  }
}
